import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Subtitle } from 'components/styled/typography'
import StreamInfo from './stream-info'

const propTypes = {
  timeLeft: PropTypes.number.isRequired,
  infoText: PropTypes.string.isRequired,
  toNextCountdown: PropTypes.bool.isRequired,
}

const StyledHeader = styled(Subtitle)`
  z-index: 2;
  font-size: ${({ theme }) => theme.space.s240};
  line-height: ${({ theme }) => theme.space.s240};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
export function Countdown({ timeLeft, infoText, toNextCountdown }) {
  if (timeLeft <= 5 && !toNextCountdown) {
    return (
      <>
        <StyledHeader className="countdown" color="white">
          {timeLeft}
        </StyledHeader>
      </>
    )
  }

  return <StreamInfo text={infoText} color="white" />
}

Countdown.propTypes = propTypes

export default Countdown
